<template>
  <div class="message-push">
    <div class="page_title">消息推送</div>

    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <!-- 推送表单 -->
        <div class="message-push-form">
          <el-form
            :model="messagePushForm"
            :rules="messagePushRules"
            ref="messagePushRef"
            label-width="100px"
          >
            <el-form-item label="推送平台:" prop="to">
              <el-radio-group v-model="messagePushForm.to" @change="changeTo">
                <el-radio :label="'1'">业务员端</el-radio>
                <el-radio :label="'2'">医生端</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="接收人员:"
              class="receive-man-box"
              prop="to_type"
            >
              <el-radio-group
                v-model="messagePushForm.to_type"
                @change="changeType"
              >
                <el-radio :label="'1'">全选所有用户</el-radio>
                <el-radio :label="'2'">选择以下筛选用户</el-radio>
                <template v-if="messagePushForm.to == 2">
                  <el-radio :label="'3'">自定义用户</el-radio>
                  <el-radio :label="'4'">excel导入</el-radio>
                  <el-radio :label="'5'">按标签添加</el-radio>
                </template>
              </el-radio-group>
            </el-form-item>

            <!-- 筛选框--选择以下筛选用户 -->
            <el-form-item
              v-if="messagePushForm.to_type != 1"
              label=""
              prop="to_object"
              class="receive-man-box"
            >
              <div v-if="messagePushForm.to_type == 2" class="receive-box">
                <component
                  v-if="filteruserRef"
                  :is="currentComponent"
                  @filteruser="filteruser"
                />
              </div>
              <!-- 自定义用户 -->
              <div v-if="messagePushForm.to_type == 3">
                <el-input
                  v-model="messagePushForm.to_object"
                  style="width: 600px"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 10 }"
                  placeholder="请填写或粘贴接收推送的手机号，多个用英文逗号隔开"
                ></el-input>
              </div>
              <!-- excel导入 -->
              <div v-if="messagePushForm.to_type == 4">
                <div class="flex">
                  <el-upload
                    class="avatar-uploader"
                    name="image"
                    :action="uploadUrl"
                    :data="uploadExtraData"
                    :headers="uploadHeaders"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeUpload"
                  >
                    <el-button v-if="fileForm.file_name" size="medium"
                      >重新选择</el-button
                    >
                    <el-button type="primary" v-else size="medium"
                      >选择文件</el-button
                    >
                  </el-upload>
                  <el-button
                    style="margin-left: 30px"
                    type="text"
                    @click="download"
                    >下载模板</el-button
                  >
                </div>
                <div style="padding-left: 130px" v-if="fileForm.file_name">
                  <span>上传文件：</span>
                  <span style="color: #666">{{ fileForm.file_name }}</span>
                </div>
                <ul style="color: #999">
                  <li>请按照模板格式完整填写数据后导入，否则无法导入</li>
                  <li>错误数据可对照文件行数修改数据后重新导入</li>
                  <li>导入数据需要时间，请耐心等待</li>
                </ul>
              </div>
            </el-form-item>
            <!-- 按标签添加 -->
            <div
              v-if="messagePushForm.to_type == 5"
              style="margin-top: -20px; padding-left: 66px"
            >
              <el-form-item label="标签类型" prop="label_from">
                <el-radio-group
                  v-model="messagePushForm.label_from"
                  @change="changeLabelFrom"
                >
                  <el-radio :label="2">手动标签</el-radio>
                  <el-radio :label="3">自动标签</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="标签" prop="platform_label_id">
                <el-select
                  v-model="messagePushForm.label_category_type"
                  placeholder="请选择"
                  style="width: 200px"
                  @change="changeLabel"
                  size="small"
                >
                  <el-option
                    v-for="item in labelTypeList"
                    :key="item.label_type"
                    :label="item.label_type_name"
                    :value="item.label_type"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-if="messagePushForm.label_category_type != ''"
                  v-model="messagePushForm.platform_label_id"
                  placeholder="请选择"
                  style="width: 200px; margin-left: 10px"
                  size="small"
                >
                  <el-option
                    v-for="item in labelList"
                    :key="item.label_id"
                    :label="item.label_name"
                    :value="item.label_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <el-form-item label="消息内容:" prop="content" class="push-content">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 10 }"
                v-model="messagePushForm.content"
              ></el-input>
            </el-form-item>

            <template v-if="messagePushForm.to == 2">
              <el-form-item label="消息标题" prop="title">
                <el-input
                  v-model="messagePushForm.title"
                  maxlength="15"
                  clearable
                  style="width: 600px"
                ></el-input>
              </el-form-item>
              <!-- 跳转内容 -->
              <div class="flex">
                <el-form-item label="跳转路由" prop="min_type">
                  <el-select
                    v-model="messagePushForm.min_type"
                    style="width: 100px"
                  >
                    <el-option
                      v-for="item in minTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="" prop="link_url" class="link-url">
                  <el-input
                    v-model="messagePushForm.link_url"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </template>

            <el-form-item>
              <el-button
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('537') : false
                "
                @click="resetForm('messagePushRef')"
                >取消</el-button
              >
              <el-button
                type="primary"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('537') : false
                "
                @click="submitForm('messagePushRef')"
                >推送</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <!-- 消息记录 -->
        <el-divider class="message-record" content-position="left"
          >消息记录</el-divider
        >

        <el-table
          v-loading="tableLoading"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
          :data="messageRecord"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'to'">
                {{ scope.row[item.prop] | toText }}
              </div>

              <div v-else-if="item.prop == 'desc'">
                <el-link
                  type="primary"
                  @click="lookUser(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1826')
                      : false
                  "
                  >{{ scope.row[item.prop] }}</el-link
                >
              </div>

              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="searchList"
        />
      </div>
    </div>
    <!-- 推送消息人员列表 -->
    <el-dialog title="详情" width="1000px" :visible.sync="dialogUser">
      <!-- 搜索条件 -->
      <div
        style="
          margin: -10px 0 10px;
          display: flex;
          height: 70px;
          align-items: center;
        "
      >
        <span style="width: 40px">姓名</span>
        <el-input
          v-model="userForm.name"
          clearable
          size="small"
          style="width: 200px; margin-right: 10px"
        ></el-input>
        <el-button type="primary" size="small" @click="searchUserBtn">
          查 询<i class="el-icon-search el-icon--right" />
        </el-button>
      </div>

      <!-- 表格 -->
      <div style="margin-top: -15px; padding: 0 10px">
        <el-table
          v-loading="userTableLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
          :data="userTableData"
          style="width: 100%"
        >
          <el-table-column
            v-for="item in userTableHeader"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            :fixed="item.fixed"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'name'">
                {{ scope.row.name }}
                <el-tag type="danger" size="small" v-if="!scope.row.status"
                  >失败</el-tag
                >
              </div>

              <div v-else-if="item.prop == 'create_time'">
                {{ scope.row.create_time | dateFormat }}
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <pagination
        v-show="userTotalNum > 0"
        :total="userTotalNum"
        :page.sync="userPagination.page"
        :limit.sync="userPagination.pageNumber"
        @pagination="getMessagePushUserList"
      />
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import message from "../../../api/message";
import common from "../../../api/common";
import Pagination from "../../../components/Pagination/index";
import FilterUser from "../filterUser/index";
import FilterDoctor from "../filterDoctor/index";
import constant from "../../../service/common/constant";
export default {
  components: {
    Pagination,
  },
  data() {
    const validateToObject = (rule, value, callback) => {
      if (this.messagePushForm.to_type != 5) {
        if (!value) {
          callback(new Error("请选择或输入接收人员"));
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      tableHeader: [
        {
          label: "推送时间",
          prop: "send_time",
          width: "160px",
        },
        {
          label: "推送平台",
          prop: "to",
          width: "160px",
        },
        {
          label: "接收人员",
          prop: "desc",
          width: "160px",
        },
        {
          label: "操作人",
          prop: "admin_name",
          width: "160px",
        },
        {
          label: "消息内容",
          prop: "content",
          width: "auto",
        },
        {
          label: "消息标题 ",
          prop: "title",
          width: "auto",
        },
        {
          label: "跳转路由 ",
          prop: "link_url",
          width: "auto",
        },
      ],
      messageRecord: [],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      // 消息推送
      messagePushForm: {
        to: "1",
        to_type: "1",
        to_object: "",
        content: "",
        title: "",
        min_type: "",
        link_url: "",
        label_from: "",
        label_category_type: "",
        platform_label_id: "",
      },
      messagePushRules: {
        to: [{ required: true, message: "请选择推送平台", trigger: "change" }],
        to_type: [
          { required: true, message: "请选择接收人员", trigger: "change" },
        ],
        to_object: [
          {
            required: true,
            validator: validateToObject,
          },
        ],
        content: [
          { required: true, message: "请输入消息内容", trigger: "blur" },
        ],

        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        label_from: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        platform_label_id: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
      },
      filteruserRef: true,
      minTypeOptions: [
        {
          label: "原生",
          value: 1,
        },
        {
          label: "H5",
          value: 2,
        },
      ],
      uploadExtraData: {
        img_type: 6,
        suffix: ".jpg",
      },
      fileForm: {
        file_name: "",
      },
      userTableHeader: [
        {
          label: "姓名",
          prop: "name",
          width: "auto",
          fixed: "left",
        },
        {
          label: "手机号",
          prop: "phone",
          width: "auto",
          fixed: false,
        },
        {
          label: "推送时间",
          prop: "create_time",
          width: "auto",
          fixed: false,
        },
      ],
      userTableData: [],
      dialogUser: false,
      userTableLoading: false,
      userForm: {
        message_id: "",
        name: "",
      },
      userTotalNum: 0,
      userPagination: {
        page: 1,
        pageNumber: 10,
      },
      labelTypeList: [],
      labelList: [],
    };
  },
  filters: {
    toText(value) {
      switch (value) {
        case 1:
          return "业务员端";
        case 2:
          return "医生端";
      }
    },
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.messagePushForm.to) {
        case "1":
          return FilterUser;
        case "2":
          return FilterDoctor;
      }
    },
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "/api/platform/upload/uploadFile";
      } else {
        return "/platform/upload/uploadFile";
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 切换推送平台
    changeTo() {
      this.messagePushForm.to_type = "1";
    },
    changeType(type) {
      this.messagePushForm.to_object = "";
      this.messagePushForm.platform_label_id = "";
      this.messagePushForm.label_category_type = "";
      this.fileForm.file_name = "";

      switch (type) {
        case "5": //按标签
          this.messagePushForm.label_from = 2;
          this.getLabelType();
          break;
      }
      this.$refs["messagePushRef"].clearValidate();
    },
    filteruser(data) {
      console.log("筛选", data);
      this.messagePushForm.to_object = data.join(",");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let params = Object.assign({}, this.messagePushForm);
          this.messagePushForm.label_from == 2
            ? (params.label_from = 1)
            : (params.label_from = 2);
          message
            .getMessagePushUserCount(params)
            .then((res) => {
              let { code, data } = res;
              if (code == 0) {
                loading.close();
                if (!data.count) {
                  this.$confirm("请输入有效的接收人员", "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                  })
                    .then(() => {})
                    .catch(() => {});
                  return;
                }
                this.$confirm(
                  `消息将发送至${
                    this.messagePushForm.to == 1 ? "业务员端" : "医生端"
                  }使用者(共 ${data.count} 人)，请谨慎操作，是否推送？`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    customClass: "message-push-confirm",
                  }
                )
                  .then(() => {
                    this.pushMessageFn();
                  })
                  .catch(() => {});
              }
              loading.close();
            })
            .catch((err) => loading.close());
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    pushMessageFn() {
      let params = Object.assign({}, this.messagePushForm);
      message.pushMessage(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message({
            type: "success",
            message: "推送成功!",
          });
          this.resetForm("messagePushRef");
          this.messagePushForm.to_object = "";
          this.pagination.page = 1;
          this.getList();
        }
      });
    },
    resetForm(formName) {
      this.filteruserRef = false;
      this.$nextTick(() => {
        this.filteruserRef = true;
      });
      this.$refs[formName].resetFields();
      this.messagePushForm.to_object = "";
      this.pagination.page = 1;
      this.getList();
    },
    // 消息记录
    getList() {
      this.tableLoading = true;
      message.getMessageList(this.pagination).then((res) => {
        let { list, total } = res.data;
        this.messageRecord = list.map((item) => {
          item.send_time = dayjs
            .unix(item.send_time)
            .format("YYYY-MM-DD HH:mm");
          return item;
        });
        this.totalNum = total;
        this.tableLoading = false;
      });
    },
    searchList() {
      this.getList();
    },
    /** 上传模块---start  */
    //上传之前
    beforeUpload(file) {
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isText && !isTextComputer) {
        this.$message.error("上传文件只能是CSV或Excel文件");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      return isText || isTextComputer;
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      let loading = this.$loading();
      let { code, data } = res;
      if (code === 0) {
        this.fileForm.file_name = file.name;
        this.messagePushForm.to_object = data.pic;
        loading.close();
      } else {
        loading.close();
        this.$message.error(res.message);
      }
      this.$refs["messagePushRef"].validate();
    },
    //下载处方模板
    download() {
      let host = `${document.location.protocol}//${window.location.host}/upload/doctor_message_push.xls`;
      location.href = host;
    },
    /** 上传模块---end  */

    // 查看接收人员
    lookUser(row) {
      let { message_id } = row;
      this.dialogUser = true;
      this.userForm.message_id = message_id;
      this.getMessagePushUserList();
    },
    // 获取接收人员
    getMessagePushUserList() {
      this.userTableLoading = true;
      let params = Object.assign({}, this.userPagination, this.userForm);
      message
        .getMessagePushUserList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.userTableData = data.list;
            this.userTotalNum = data.total;
          }
          this.userTableLoading = false;
        })
        .catch((err) => (this.userTableLoading = false));
    },
    // 查询接收人员
    searchUserBtn() {
      this.userPagination.page = 1;
      this.getMessagePushUserList();
    },

    /**--- 按标签添加-start --- */
    changeLabelFrom(value) {
      this.messagePushForm.platform_label_id = "";
      this.messagePushForm.label_category_type = "";
      this.userNum = 0;
      this.getLabelType();
      this.$nextTick(() => {
        this.$refs["messagePushRef"].clearValidate();
      });
    },
    changeLabel(value) {
      this.getLabel();
      this.messagePushForm.platform_label_id = "";
      this.$nextTick(() => {
        this.$refs["messagePushRef"].clearValidate();
      });
    },
    getLabelType() {
      return new Promise(async (resolve) => {
        const loading = this.$loading();
        let params = {
          type: this.messagePushForm.label_from,
        };
        let { data } = await common.getLabelType(params);
        this.labelTypeList = data.list;
        if (this.messagePushForm.label_category_type == 0) {
          this.messagePushForm.label_category_type = data.list[0].label_type;
          this.messagePushForm.platform_label_id = "";
          this.$nextTick(() => {
            this.$refs["messagePushRef"].clearValidate();
          });
        }
        loading.close();
        resolve(data);
        this.getLabel();
      });
    },
    getLabel() {
      return new Promise(async (resolve) => {
        const loading = this.$loading();
        let params = {
          type: this.messagePushForm.label_from,
          label_type: this.messagePushForm.label_category_type,
        };

        let { data } = await common.getLabel(params);
        this.labelList = data.list;
        loading.close();
        resolve(data);
      });
    },
    /**--- 按标签添加-end --- */
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.message-push {
  .message-push-form {
    ::v-deep .el-form-item__content {
      height: auto !important;
    }
    .push-content {
      ::v-deep .el-form-item__content {
        width: 600px;
      }
    }
    .receive-man-box {
      position: relative;
      .receive-box {
        display: flex;
        align-items: center;
        .receive-style {
          width: 246px;
          border: 1px solid #ebeef5;
          border-radius: 10px;
          border-bottom-right-radius: 2px;
          box-sizing: border-box;
          .title {
            background-color: #f5f7fa;
            border-bottom: 1px solid #ebeef5;
            padding: 0 10px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            display: flex;
            justify-content: space-between;
            color: #707070;
          }
          .el-checkbox-group {
            height: 400px;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            padding: 0 10px;
            .el-checkbox {
              height: 30px;
            }
            ::v-deep .el-checkbox__label {
              font-size: 16px;
              .name {
                display: inline-block;
                width: 60px;
              }
            }
            &::-webkit-scrollbar-track-piece {
              background-color: #f5f7fa;
            }

            &::-webkit-scrollbar {
              width: 4px;
            }

            &::-webkit-scrollbar-thumb {
              background: #669961;
              border-radius: 20px;
            }
          }
        }
        .receive-controls {
          margin: 0 20px;
        }
      }
    }
    .link-url {
      ::v-deep .el-form-item__content {
        margin-left: 10px !important;
        .el-input {
          width: 490px;
        }
      }
    }
  }
  .message-record {
    .el-divider__text {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
